import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import './Dashboard.css';

const Dashboard = () => {
    const navigate = useNavigate();

    // Dữ liệu các kỹ năng được cập nhật với icon và mô tả tiếng Anh mới
    const skills = [
        { 
            id: 'reading', 
            title: 'Reading', 
            icon: '/images/to1.jpg', 
            desc: 'Master academic texts and improve your comprehension speed.', 
            color: '#1a73e8',
            badge: 'Focus'
        },
        { 
            id: 'listening', 
            title: 'Listening', 
            icon: '/images/to2.jpg', 
            desc: 'Get used to different accents and catch key information easily.', 
            color: '#34a853',
            badge: 'Active'
        },
        { 
            id: 'writing', 
            title: 'Writing', 
            icon: '/images/to3.jpg', 
            desc: 'Structure your essays perfectly and expand your vocabulary.', 
            color: '#f9ab00',
            badge: 'Creative'
        }
    ];

    return (
        <div className="dashboard-container">
            {/* Header giữ nguyên logic của bạn */}
            <Header />

            <main className="dashboard-main">
                {/* Section chào mừng được làm mới theo phong cách chuyên nghiệp */}
                <div className="welcome-section">
                    <div className="welcome-text">
                        <h2>Welcome back! 👋</h2>
                        <p>Your IELTS journey continues today. Which skill will you conquer?</p>
                    </div>
                    {/* Thêm câu nói truyền cảm hứng để tạo động lực */}
                    <div className="motivation-quote">
                        <span>"Success is the sum of small efforts, repeated day in and day out."</span>
                    </div>
                </div>

                <div className="skills-grid">
                    {skills.map(skill => (
                        <div 
                            key={skill.id} 
                            className="skill-card" 
                            onClick={() => navigate(`/select/${skill.id}`)}
                        >
                            <div className="card-header">
                                <span className="skill-badge" style={{ color: skill.color, backgroundColor: `${skill.color}15` }}>
                                    {skill.badge}
                                </span>
                            </div>

                            <div className="skill-icon-wrapper" style={{ borderColor: skill.color }}>
                                <img src={skill.icon} alt={skill.title} className="skill-image" />
                            </div>

                            <div className="skill-content">
                                <h3>{skill.title}</h3>
                                <p>{skill.desc}</p>
                            </div>
                            
                            <div className="card-footer">
                                <button className="start-btn">
                                    Start Practice <span>→</span>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Banner bổ sung phía dưới để tăng tính thẩm mỹ và động lực */}
                <div className="learning-banner">
                    <div className="banner-info">
                        <h4>Ready for a full Mock Test?</h4>
                        <p>Complete a full exam under real conditions to evaluate your current band score.</p>
                    </div>
                    <button className="btn-mock-test">Coming Soon</button>
                </div>
            </main>
        </div>
    );
};

export default Dashboard;